module.exports = __webpack_public_path__ + "img/index-icon.dca4b1de.png";